module.exports = __webpack_public_path__ + "static/media/vandegraff.90aa9d36.jpg";